import React from 'react';
import './Projects.css';

const Projects = () => {
  const projectsData = [
    {
      title: "Logra – Fitness Tracker",
      description:
        "Fitness tracking platform designed for consistent training, enabling users to log workouts, monitor streaks, and visualize progress through a clean, responsive experience.",
      category: "Health & Fitness",
      icon: "./images/log-fitness-tracker.png",
      link: "https://fc-fitness-tracker.web.app/",
    },
    {
      title: "Keyboard",
      description:
        "Interactive piano widget built with React + TypeScript, enabling real-time audio playback and responsive controls for learning-focused music applications.",
      category: "Music",
      icon: "./images/keyboard.png",
      link: "/projects/keyboard/",
    },
    {
      title: "Base 10 Blocks",
      description:
        "Virtual Base 10 Blocks manipulative built with React + TypeScript, helping students understand place value, number relationships, and arithmetic through interactive visuals.",
      category: "Math",
      icon: "./images/basetenblocks.png",
      link: "/projects/basetenblocks/",
    },
    {
      title: "Dynamic Quiz Engine",
      description:
        "Enterprise-ready quiz engine with SCORM compliance, multilingual and RTL support, accessibility-first UX, and robust scoring with learner review workflows.",
      category: "Education",
      icon: "./images/quiz.png",
      link: "/projects/quiz/",
    },
    {
      title: "Interactive 2D & 3D Geometry Explorer",
      description:
        "An engaging mathematics learning tool that lets students explore 2D and 3D shapes, adjust dimensions, and understand geometric concepts through real-time interactive visualizations.",
      category: "Education",
      icon: "./images/geometry.png",
      link: "/projects/math/",
    },
    {
      title: "AR/3D Car",
      description:
        "Immersive AR/3D car experience featuring real-time interaction, component-level controls, and contextual hotspots to demonstrate product functionality in depth.",
      category: "AR",
      icon: "./images/ar-fordendy.jpg",
    },
    // Add more project objects for other categories
  ];

  return (
    <section className="projects">
      <div className="projects-content">
        <h2 className="projects-title">Works in Focus</h2>
        <div className="projects-grid">
          {projectsData.map((project, index) => {
            const tile = (
              <>
                <div className="project-icon">
                  <img src={project.icon} alt={project.description} />
                </div>
                <h3 className="project-title">{project.title}</h3>
                <p className="project-description">{project.description}</p>
                {/* <span className="project-category">{project.category}</span> */}
              </>
            );

            if (project.link) {
              return (
                <a
                  key={index}
                  className="project-box"
                  href={project.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {tile}
                </a>
              );
            }

            return (
              <div key={index} className="project-box">
                {tile}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Projects;
